export default __webpack_public_path__ + "images/NH.1bca217.png";